import { RadioGroup } from "@headlessui/react";
import { DivProps } from "react-html-props";

export default function InputRadio<T extends string | number>(
  p: Pick<DivProps, "className" | "autoFocus" | "aria-label" | "children"> & {
    name?: string;
    value?: T;
    defaultValue?: T;
    onChange?: (value: T) => void;
    disabled?: boolean;
  },
) {
  const { children, ...rest } = p;
  return <RadioGroup {...rest}>{children}</RadioGroup>;
}
